import React from "react";
import "./HomeApp.css";

import { useTypedOnScroll } from "../../utils/hooks/useTypedOnScroll";

const Credibility = () => {
  const cards = [
    {
      title: "Unmatched Data Processing",
      points: [
        "30M+ lives processed weekly",
        "250M+ lives on platform",
        "21B total member records",
        "90-day implementation",
      ],
      link: "",
    },
    {
      title: "Unparalleled Security & Validation",
      points: [
        "HIPPA compliant",
        "HITRUST certified",
        "SOC 2/Type 2 compliant",
      ],
      link: "",
    },
    {
      title: "Uncovering Powerful Insights",
      points: [
        "10B+ savings identified",
        "2.4x increase in patient engagement",
        "$200 PMPY in savings",
      ],
      link: "",
    },
  ];
  const renderCards = () => {
    const card = cards.map((card, index) => {
      const [ref] = useTypedOnScroll([card.title], {
        startDelay: (index + 1) * 1000,
      });
      return (
        <div className="card flex flex-col w-10/12 md:w-full lg:w-1/3 mx-auto items-center py-12 lg:py-0">
          <div className="card__data flex flex-col h-48">
            <h4
              key={index}
              ref={ref}
              className="font-bold text-xl text-primary-blue-content text-center pb-6"
            ></h4>
            <div className="card__point text-center">
              {card.points.map((point, index) => (
                <p key={index} className="mb-0 text-primary-blue-content">
                  {point}
                </p>
              ))}
            </div>
          </div>
        </div>
      );
    });
    return card;
  };

  return (
    <section>
      <div className="w-full h-full bg-light-blue-background">
        <div className="cards__container w-11/12 mx-auto flex flex-col lg:flex-row py-4 lg:py-16 max-w-7xl text-primary-blue-content">
          {renderCards()}
        </div>
      </div>
    </section>
  );
};

export default Credibility;
